import * as React from "react";

// By: ion
// See: https://v0.app/icon/ion/reload
// Example: <IconIonReload width="24px" height="24px" style={{color: "#1410cb"}} />

export const RefreshIcon = ({
  height = "1.6em",
  strokeWidth = "42",
  focusable = "false",
  ...props
}: Omit<React.SVGProps<SVGSVGElement>, "children">) => (
  <svg
    role="img"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    height={height}
    
    focusable={focusable}
    {...props}
  >
    <path
      fill="none"
      stroke="#3E88EF"
      strokeLinecap="round"
      strokeMiterlimit="10"
      strokeWidth={strokeWidth}
      d="m400 148l-21.12-24.57A191.43 191.43 0 0 0 240 64C134 64 48 150 48 256s86 192 192 192a192.09 192.09 0 0 0 181.07-128"
    />
    <path
      fill="#3E88EF"
      d="M464 97.42V208a16 16 0 0 1-16 16H337.42c-14.26 0-21.4-17.23-11.32-27.31L436.69 86.1C446.77 76 464 83.16 464 97.42"
    />
  </svg>
);